const common_message_id = {
    delete_msg_title: "Apakah anda yakin?",
    delete_msg_text: "Data yang dihapus tidak dapat dipulihkan."
}

export default common_message_id;